<template>
<v-content>
    <v-toolbar flat dense>
        <v-btn icon title="Таблиця">
            <v-icon @click="setViewSw('list')" :color="viewSw === 'list' ? 'blue' : 'grey'">view_list</v-icon>
        </v-btn>
        <v-btn icon title="Мозаїка">
            <v-icon @click="setViewSw('module')" :color="viewSw === 'module' ? 'blue' : 'grey'">view_module</v-icon>
        </v-btn>
        <v-btn icon title="Список">
            <v-icon @click="setViewSw('headline')" :color="viewSw === 'headline' ? 'blue' : 'grey'">view_headline</v-icon>
        </v-btn>
        <v-menu offset-y v-model="menu" :close-on-content-click="false" :nudge-width="300">
            <template v-slot:activator="{ on }">
                <v-btn icon v-on="on" title="Налаштування колонок">
                    <v-icon color="grey">build</v-icon>
                </v-btn>
            </template>

            <v-card>
                <v-system-bar window dark color="blue darken-3">
                    Налаштування колонок
                    <v-spacer></v-spacer>
                    <v-btn icon @click="menu = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-system-bar>
                <v-list>
                    <v-list-tile v-for="(item,index) in headers" :key="index">
                        <v-list-tile-action>
                            <v-switch v-model="headers[index].selected" color="purple" @change="saveCols()"></v-switch>
                        </v-list-tile-action>
                        <v-list-tile-title>{{item.text}}</v-list-tile-title>
                    </v-list-tile>
                </v-list>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @click="menu = false">Закрити</v-btn>
                </v-card-actions>
            </v-card>

        </v-menu>
        <v-btn icon @click="getDataFromApi()" title="Оновити">
            <v-icon color="grey">cached</v-icon>
        </v-btn>
    </v-toolbar>
    <div style="height: 0px; display: block; position: absolute; width: 100%;">
        <v-progress-linear color="blue" :indeterminate="true" v-if="loading" ></v-progress-linear>
    </div>
    <v-data-table v-if="viewSw === 'list'" disable-initial-sort :headers="filteredHeaders" :items="list" :rows-per-page-items="rowsPerPageItems" rows-per-page-text="на стор." :pagination.sync="pagination" :total-items="totalList"  class="elevation-1">
        <template slot="items" slot-scope="props">
            <tr @click="openCardMobile(props.item.id)" @dblclick="openCardDesctop(props.item.id)" :bgcolor="props.item.statusColor">
                <td v-for="(col,index) in headers" v-if="headers[index].selected" :class="'text-xs-'+headers[index].align">
                    {{ props.item[col.value] }}
                </td>
            </tr>
        </template>
        <template v-slot:no-data>
            немає даних
        </template>
    </v-data-table>

    <v-list two-line v-if="viewSw === 'headline'">
        <template v-for="(item, index) in list">
            <v-list-tile :key="item.id" avatar ripple @click="$router.push(`/card/${item.id}`)">
                <v-list-tile-content>
                    <v-list-tile-title>{{ item.product }}</v-list-tile-title>
                    <v-list-tile-sub-title class="text--primary">{{ item.oblast}}, {{ item.city }}</v-list-tile-sub-title>
                    <v-list-tile-sub-title>{{ item.serialCode }}</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                    <v-list-tile-action-text>{{ item.id }}</v-list-tile-action-text>
                    <v-icon v-if="selected.indexOf(index) < 0" color="grey lighten-1">
                        star_border
                    </v-icon>

                    <v-icon v-else color="yellow darken-2">
                        star
                    </v-icon>
                </v-list-tile-action>

            </v-list-tile>
            <v-divider v-if="index + 1 < list.length" :key="index"></v-divider>
        </template>
    </v-list>

    <v-container fluid grid-list-md v-if="viewSw === 'module'">
        <v-data-iterator :items="list" :rows-per-page-items="rowsPerPageItems" :total-items="totalList" :pagination.sync="pagination" rows-per-page-text="на стор." content-tag="v-layout" row wrap>
            <template slot="item" slot-scope="props">
                <v-flex xs12 sm6 md4 lg3>
                    <v-card @click="openCardMobile(props.item.id)" @dblclick="openCardDesctop(props.item.id)">
                        <v-system-bar window dark color="blue darken-1">
                            <v-toolbar-title># {{ props.item.id }}</v-toolbar-title>
                        </v-system-bar>
                        <v-list two-line class="pr-2" v-for="(col,index) in headers" v-if="headers[index].selected" :class="'text-xs-'+headers[index].align">
                            <v-list-tile>
                                <v-list-tile-content>
                                    {{ props.item[col.value] }}
                                    <v-list-tile-sub-title> {{ col.text }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider></v-divider>
                        </v-list>
                    </v-card>
                </v-flex>
            </template>
            <template v-slot:no-data>
                немає даних
            </template>
        </v-data-iterator>
    </v-container>
    <div class="text-xs-center pt-2">
        <v-pagination v-model="pagination.page" :length="pages" :total-visible="7"></v-pagination>
    </div>
</v-content>
</template>

<script>
import {
    HTTP
} from '../http-common'

export default {

    props: {},
    data() {
        return {
            menu: false,
            message: false,
            error: [],
            totalList: 0,
            list: [],
            selected: [2],
            loading: true,
            pagination: {},
            rowsPerPageItems: [8, 16, 32, 64],
            viewSw: 'list',

            headers: [{
                    text: 'Номер',
                    align: 'left',
                    sortable: true,
                    value: 'id',
                    selected: true
                },
                {
                    text: 'Статус',
                    value: 'statusName',
                    selected: false

                },
                {
                    text: 'Місто',
                    value: 'city',
                    selected: true
                },
                {
                    text: 'Область',
                    value: 'oblast',
                    selected: false
                },
                {
                    text: 'Район',
                    value: 'region',
                    selected: false
                },
                {
                    text: 'Товар',
                    value: 'product',
                    selected: true
                },
                {
                    text: 'Серійний номер',
                    align: 'right',
                    value: 'serialCode',
                    selected: true
                },
                {
                    text: 'Дата продажу',
                    value: 'saleDate',
                    selected: false
                },
                {
                    text: 'Номер гарантійного талону',
                    value: 'garantyCode',
                    selected: false
                },
                {
                    text: 'Тип ремонту',
                    value: 'repairType',
                    selected: true
                },
                {
                    text: 'ПІБ клієнта',
                    value: 'clientName',
                    selected: false
                },
                {
                    text: 'Адреса клієнта',
                    value: 'clientAddress',
                    selected: false
                },
                {
                    text: 'Телефон клієнта',
                    value: 'clientPhone',
                    selected: false
                },
                {
                    text: 'Опис дефекту',
                    value: 'defect',
                    sortable: false,
                    selected: true
                },
                {
                    text: 'Тип послуги',
                    value: 'serviceStatus',
                    align: 'right',
                    selected: false
                },
                {
                    text: 'Назва виконавця',
                    value: 'contractorName',
                    align: 'right',
                    selected: false
                },
            ]
        }
    },
    watch: {
        pagination: {
            handler() {
                this.getDataFromApi()
            },
            deep: true
        }
    },
    computed: {
        pages() {
            if (this.pagination.rowsPerPage == null ||
                this.totalList == null
            ) return 0

            return Math.ceil(this.totalList / this.pagination.rowsPerPage)
        },
        filteredHeaders() {
            return this.headers.filter(h => h.selected)
        },
    },
    mounted() {
        const self = this
        this.$root.$on('reloadRepairTable', function () {
            self.getDataFromApi()
        })
    },
    created() {
        if (!localStorage.pagination || localStorage.pagination == '') {
            localStorage.pagination = '{}'
        }
        if (!localStorage.viewSw || localStorage.viewSw == '') {
            localStorage.viewSw = 'list'
        }
        this.viewSw = localStorage.viewSw
        this.pagination = this.getLocalStorage('pagination')
        if (localStorage.cols) {
            this.headers = this.getLocalStorage('cols')
        }

    },
    methods: {
        openCardDesctop(id) {
            if (screen.width >= 500) {
                this.$router.push(`/card/${id}`)
            }
        },
        openCardMobile(id) {
            if (screen.width < 500) {
                this.$router.push(`/card/${id}`)
            }
        },
        saveCols() {
            this.setLocalStorage('cols', this.headers)
        },
        getLocalStorage(f) {
            return JSON.parse(localStorage[f])
        },
        setLocalStorage(f, v) {
            localStorage[f] = JSON.stringify(v)
        },
        showColumn(col) {
            let found = this.headers.find(function (v) {
                if (v.value === col) {
                    return v.selected
                }
            })
            return found
        },
        setViewSw(f) {
            this.viewSw = f
            localStorage.viewSw = f
        },
        getDataFromApi() {
            this.loading = true
            const {
                sortBy,
                descending,
                page,
                rowsPerPage
            } = this.pagination

            this.setLocalStorage('pagination', this.pagination)
            let items = this.list
            const total = items.length

            if (this.pagination.sortBy) {
                items = items.sort((a, b) => {
                    const sortA = a[sortBy]
                    const sortB = b[sortBy]

                    if (descending) {
                        if (sortA < sortB) return 1
                        if (sortA > sortB) return -1
                        return 0
                    } else {
                        if (sortA < sortB) return -1
                        if (sortA > sortB) return 1
                        return 0
                    }
                })
            }
            if (rowsPerPage > 0) {
                items = items.slice((page - 1) * rowsPerPage, page * rowsPerPage)
            }
            HTTP.get(`repair_card/list`, {
                    params: {
                        sortBy: this.pagination.sortBy,
                        descending: this.pagination.descending,
                        page: this.pagination.page,
                        rowsPerPage: this.pagination.rowsPerPage,
                        status: this.$route.query.status,
                        query: this.$route.query.query
                    }
                })
                .then(response => {
                    if (response.data) {
                        this.list = response.data.data
                        this.totalList = Number(response.data.total)
                    }
                })
                .catch(e => {
                    this.error.push(e)
                })
                .finally(
                    () => {
                        this.loading = false
                    }
                )
        }
    }
}
</script>
